import React, { useEffect, useRef } from "react";
import { classNames } from "@greeter/util";
import { HTMLMotionProps, motion } from "motion/react";
import { dropInOutFromBottom } from "@greeter/motion";

import css from "./BottomBar.module.scss";

export type BottomBarButtonProps = React.ComponentProps<"button"> & {
  highlight?: boolean;
};
export function BottomBarButton({ className, ...props }: BottomBarButtonProps) {
  return (
    <button
      {...classNames(
        className,
        css.BottomBarButton,
        !props.disabled && props.highlight && css.Highlight
      )}
      {...props}
    />
  );
}

export type BottomBarProps = HTMLMotionProps<"div"> & {
  theme?: "default" | "none";
};
export function BottomBar({ className, ...props }: BottomBarProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;

    document.body.style.setProperty(
      "--bottom-bar-height",
      ref.current.getBoundingClientRect().height + "px"
    );
  }, []);

  return (
    <motion.div
      ref={ref}
      {...classNames(
        className,
        css.BottomBar,
        (!props.theme || props.theme === "default") && css.BottomBarDefault
      )}
      {...props}
      {...dropInOutFromBottom}
    />
  );
}

BottomBar.Button = BottomBarButton;
